<div>
  <h3>{{item.translation_key||item.outcome_label || 'outcome'| translation|translationFromString | transformText :item?.text_transform}}</h3>
  <div class="flex-list">
    <div style="flex:1">
      <div class="form-field">
        <label>{{item.translation_key||item.outcome_label || 'outcome'| translation|translationFromString | transformText :item?.text_transform}} {{'verb'| translation}}</label>
        <br>
<p-autocomplete [(ngModel)]="_term" [group]="true" optionGroupChildren="terms" [suggestions]="filterd" (completeMethod)="filterList($event)" placeholder="{{item.outcome_label || 'Outcome'}} Verb" fluid ngDefaultControl>
  <ng-template let-group #group>
    <div class="flex items-center">
        <strong>{{ group.name }}</strong>
    </div>
</ng-template>
</p-autocomplete>

        
    <!--    <input type="text" pInputText required [nbAutocomplete]="autoGroup" [(ngModel)]="_term" placeholder="{{item.outcome_label || 'Outcome'}} Verb" (input)="filterList()" fluid>
        <nb-autocomplete #autoGroup (selectedChange)="selectedVerb($event)">
          <nb-option-group *ngFor="let item of filterd" [title]="item.name">
            <nb-option *ngFor="let verb of item.terms" [value]="verb">
              {{verb}}
            </nb-option>
          </nb-option-group>
        </nb-autocomplete> -->
      </div>
    </div>
  

    <div style="flex:2">

      <div class="form-field">
        <label>{{item.translation_key||item.outcome_label || 'outcome'| translation}} {{'description'| translation|translationFromString | transformText :item?.text_transform}}</label>
        <textarea pTextarea [(ngModel)]="text" placeholder="{{item.outcome_label || 'Outcome'}} Description" (input)="setValue('text', text)" fluid></textarea>
      </div>
    </div>
  </div>


</div>
